module.exports = __webpack_public_path__ + "static/img/fish37.58406b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish37.png
// module id = 5bdB
// module chunks = 0